import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  Home, 
  Users, 
  Trophy, 
  TrendingUp, 
  BarChart, 
  Activity,
  GitCompare,
  Eye
} from 'lucide-react';

const Sidebar = () => {
  const navItems = [
    { to: '/', icon: Home, label: 'Dashboard' },
    { to: '/overview', icon: Eye, label: 'Overview' },
    { to: '/leaderboards', icon: Trophy, label: 'Leaderboards' },
    { to: '/compare', icon: GitCompare, label: 'Player Compare' },
    { to: '/gains', icon: Activity, label: 'Gains' },
    { to: '/stats-history', icon: BarChart, label: 'Stats History' },
  ];

  return (
    <nav className="sidebar">
      <div style={{ marginBottom: '2rem' }}>
        <h3 style={{ fontSize: '1.1rem', marginBottom: '1rem', opacity: 0.8 }}>Navigation</h3>
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem',
              fontSize: '0.95rem',
            }}
          >
            <item.icon size={18} />
            {item.label}
          </NavLink>
        ))}
      </div>
      
      <div style={{ borderTop: '1px solid #34495e', paddingTop: '1rem', marginTop: 'auto' }}>
        <p style={{ fontSize: '0.8rem', opacity: 0.6, textAlign: 'center' }}>
          Stats Dashboard v1.0
        </p>
      </div>
    </nav>
  );
};

export default React.memo(Sidebar);
